import type React from 'react';
import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { ROUTES } from '../../../constants/Constants';
import useAppNavigation from '../../../hooks/useAppNavigation';
import useForgotModal from '../../../hooks/useForgotModal';
import useLoginModal from '../../../hooks/useLoginModal';
import useRegisterModal from '../../../hooks/useRegisterModal';
import useResetPasswordModal from '../../../hooks/useResetPasswordModal';
import useUser from '../../../hooks/useUser';
import type { AppSsrFetchedDataType } from '../../../server/AppSsr';
import Spinner from '../../layout/Spinner/Spinner';

interface ResetPasswordProps {
  ssrFetchedData: AppSsrFetchedDataType;
}

const ResetPassword: React.FC<ResetPasswordProps> = ({ ssrFetchedData }) => {
  const [searchParams] = useSearchParams();
  const resetPasswordModal = useResetPasswordModal();
  const loginModal = useLoginModal();
  const registerModal = useRegisterModal();
  const forgotModal = useForgotModal();
  const { t } = useTranslation();
  const { navigate, toLocalizedRoute } = useAppNavigation();
  const [resetReady, setResetReady] = useState<boolean>(false);

  const { currentUser } = useUser();

  useEffect(() => {
    const code = searchParams.get('code');
    if (code) {
      setResetReady(true);
      resetPasswordModal.onOpen();
    } else {
      toast.error(t('static.reset.notification_code_not_found'));
      navigate(toLocalizedRoute(ROUTES.HOME_ROUTE));
    }
  }, []);

  useEffect(() => {
    if (
      resetReady &&
      !resetPasswordModal.isOpen &&
      !registerModal.isOpen &&
      !loginModal.isOpen &&
      !forgotModal.isOpen
    ) {
      navigate(toLocalizedRoute(ROUTES.HOME_ROUTE));
    }
  }, [resetPasswordModal]);

  useEffect(() => {
    if (currentUser) {
      navigate(toLocalizedRoute(ROUTES.HOME_ROUTE));
    }
  }, [currentUser]);

  return (
    <div className="flex min-h-[calc(100dvh)] flex-col items-center justify-center">
      {!resetPasswordModal.isOpen && <Spinner color="fill-sky-600" />}
    </div>
  );
};

export default ResetPassword;
